import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { css, styled } from 'styled-components';
import { Box } from '@design-system/box';
import { Skeleton } from '@design-system/skeleton';
import { useBreakpoint } from '@design-system/theme';
export const StaticGoogleMapLoading = ({ hasFooter, }) => {
    const breakpoint = useBreakpoint();
    const height = breakpoint === 's' ? 124 : 172;
    return (_jsxs(_Fragment, { children: [_jsx(Image, { "$hasFooter": hasFooter, height: height, width: "100%" }), hasFooter && (_jsxs(Box, { minHeight: "64px", p: 3, children: [_jsx(Box, { children: _jsx(Skeleton, { height: 24, width: 24 }) }), _jsxs(Box, { flexDirection: "column", ml: "9px", children: [_jsx(Box, { children: _jsx(Skeleton, { height: 17, width: 240 }) }), _jsxs(Box, { mt: "6px", children: [_jsx(Skeleton, { height: 17, mr: 1, width: 60 }), "-", _jsx(Skeleton, { height: 17, ml: 1, width: 60 })] })] })] }))] }));
};
const Image = styled(Skeleton) `
  border-top-left-radius: ${({ theme }) => `${theme.themeVariables.globalBorderRadius}px`};
  border-top-right-radius: ${({ theme }) => `${theme.themeVariables.globalBorderRadius}px`};

  ${({ $hasFooter }) => !$hasFooter &&
    css `
      border-bottom-left-radius: ${({ theme }) => `${theme.themeVariables.globalBorderRadius}px`};
      border-bottom-right-radius: ${({ theme }) => `${theme.themeVariables.globalBorderRadius}px`};
    `}
`;
//# sourceMappingURL=StaticGoogleMapLoading.js.map